<template>
  <div>
    <!-- 上面导航 -->
    <div class="tab">
      <ul class="clearfix">
        <li @click="clickChangeTab(1)" :class="activeIndex==1? 'current':'' ">
          <a href="javascript:;" :class="activeIndex==1? 'current':'' ">IT部</a>
        </li>
        <li @click="clickChangeTab(2)" :class="activeIndex==2? 'current':'' ">
          <a href="javascript:;" :class="activeIndex==2? 'current':'' ">实验室</a>
        </li>
        <li @click="clickChangeTab(3)" :class="activeIndex==3? 'current':'' ">
          <a href="javascript:;" :class="activeIndex==3? 'current':'' ">销售部</a>
          <i class="el-icon-arrow-down pullDown"></i>
          <div class="pullDownBox" v-if="pull">
            <div v-for="(item, index) in list" :key="index" class="pullList" @click="clickchange(index)">
              <a href="javascript:;" >{{
                item.position
              }}</a>
            </div>
          </div>
        </li>
        <!-- 下拉框 -->
      </ul>
      <!-- 下面内容 -->
      <div
        v-if="activeIndex === 1"
        v-for="(item, index) in departmentList"
        :key="index"
        class="tabOut"
      >
        <div class="tabBox" v-if="item.department == '1'">
          <p class="headline">{{ item.position }}</p>
          <div class="tabText">
            <p>技能要求:</p>
            <div>{{ item.require }}</div>
            <p class="tabP">福利待遇:</p>
            <div v-for="(pay, index) in item.pays" :key="index">
              {{ index + 1 }}.{{ pay }}
            </div>
          </div>
          <div class="tabText">
            <p>岗位职责:</p>
            <div v-for="(duty, index) in item.dutys" :key="index">
              {{ index + 1 }}.{{ duty }}
            </div>
          </div>
          <div class="tabText">
            <p>任职资格:</p>
            <div
              v-for="(qualification, index) in item.qualifications"
              :key="index"
            >{{index+1}}.{{qualification}}</div>
          </div>
        </div>
      </div>
      <div
        v-if="activeIndex === 2"
        v-for="(item, index) in departmentList"
        :key="index"
        class="tabOut"
      >
        <div class="tabBox" v-if="item.department == '2'">
          <p class="headline">{{ item.position }}</p>
          <div class="tabText">
            <p>技能要求:</p>
            <div>{{ item.require }}</div>
            <p class="tabP">福利待遇:</p>
            <div v-for="(pay, index) in item.pays" :key="index">
              {{ index + 1 }}.{{ pay }}
            </div>
          </div>
          <div class="tabText">
            <p>岗位职责:</p>
            <div v-for="(duty, index) in item.dutys" :key="index">
              {{ index + 1 }}.{{ duty }}
            </div>
          </div>
          <div class="tabText">
            <p>任职资格:</p>
            <div
              v-for="(qualification, index) in item.qualifications"
              :key="index"
            >{{index+1}}.{{qualification}}</div>
          </div>
        </div>
      </div>
      <div
        v-if="activeIndex === 3"
        v-for="(item, index) in list"
        :key="index"
        class="tabOut"
      >
        <div class="tabBox" v-show="tabIndex === index">
          <p class="headline">{{item.position}}</p>
          <div class="tabText">
            <p>技能要求:</p>
            <div>{{ item.require }}</div>
            <p class="tabP">福利待遇:</p>
            <div v-for="(pay, index) in item.pays" :key="index">
              {{ index + 1 }}.{{ pay }}
            </div>
          </div>
          <div class="tabText">
            <p>岗位职责:</p>
            <div v-for="(duty, index) in item.dutys" :key="index">
              {{ index + 1 }}.{{ duty }}
            </div>
          </div>
          <div class="tabText">
            <p>任职资格:</p>
            <div
              v-for="(qualification, index) in item.qualifications"
              :key="index"
            >{{index+1}}.{{qualification}}</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      activeIndex: 1, // 中间替换量
      departmentList: [],
      tabIndex: 0,
      showPrise: false,
      pull: false,
      list: []
    }
  },
  mounted() {
    this.init()
  },
  methods: {
    // 一级切换
    clickChangeTab(index) {
      const vm = this
      
      vm.activeIndex = index
      // console.log(this.activeIndex)
      if (index === 3) {
        vm.pull = !this.pull
      } else {
        vm.pull = false
      }
    },
    // 二级切换
    clickchange(index) {
      const vm = this
      console.log(index)
      vm.tabIndex = index
    },
    init() {
      let vm = this
      let params = {
        pageNo: 1,
        pageSize: 100000
      }
      vm.axios
        .get('/employ/queryEmployList', { params: params })
        .then(res => {
          // console.log(res)
          let joblsst = res.data.employList.list
          console.log(joblsst)
          vm.departmentList = joblsst
          vm.departmentList.forEach(el => {
            el.dutys = el.duty.split('|')
            el.pays = el.pay.split('|')
            el.qualifications = el.qualification.split('|')
            if (el.department === '3') {
              vm.list.push(el)
            }
          })
        })
        .catch(error => {})
    }
  }
}
</script>

<style lang="scss" scoped>
.currentB {
  color: #fff;
}
.tab {
  width: 1525px;
  height: 600px;
  // background-color: #e5e5e5;
  margin: 100px auto;

  ul {
    // width: 100%;
    height: 60px;
    padding-left: 281px;
    li {
      width: 300px;
      height: 60px;
      font-size: 22px;
      background-color: #e5f0f8;
      text-align: center;
      line-height: 60px;
      float: left;
      margin: 0 30px 0 0;
      cursor: pointer;
      border-radius: 5px;
      &:nth-of-type(3) {
        position: relative;
        .pullDownBox {
          position: absolute;
          top: 80px;
          // right: 284px;
          // bottom: -128px;
          width: 300px;
          height: auto;
          min-height: 150px;
          background: rgba(255, 255, 255, 1);
          box-shadow: 0px 1px 7px 0px rgba(0, 0, 0, 0.22);
          border-radius: 4px;
          margin-top: 3px;
          &::before {
            position: absolute;
            left: 31px;
            top: -20px;
            content: '';
            width: 0;
            height: 0;
            border-left: 20px solid transparent;
            border-right: 20px solid transparent;
            border-bottom: 20px solid #fff;


          }
          .pullList {
            height: 100%;
            // padding: 10px 0 0 10px;
            &:hover {
              background-color: #0068B7;
              color: #fff;
              a {
                color: #fff;
              }
            }
            a {
              font-size: 16px;
              color: #0068B7;
            }
          }
        }
      }
    }

    .current {
      background-color: #0068b7;
      color: #fff;
    }
  }
  .tabBox {
    width: 100%;
    height: 507px;
    background-color: #e5f0f8;
    margin: 38px 0 0 0;
    .headline {
      width: 100%;
      height: 37px;
      font-size: 20px;
      font-weight: 500;
      line-height: 50px;
      text-align: center;
      padding: 15px 0 29px 0;
    }
    .tabText {
      width: 30%;
      height: 80%;
      color: rgba(51, 51, 51, 1);
      float: left;
      margin: 0 0 0 36px;
      p {
        font-size: 18px;
        font-weight: 400;
        padding: 0 0 46px 0;
      }
      div {
        font-size: 15px;
        line-height: 30px;
      }
      .tabP {
        padding: 30px 0 30px 0;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/website/contact/component/employ.vue